var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t.__(
              "dashboard.forms.BankAccountBalanceSettingForm.select_account_to_display"
            ),
            prop: "accountsId"
          }
        },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-5",
              attrs: {
                multiple: "",
                placeholder: _vm.$t.__(
                  "dashboard.forms.BankAccountBalanceSettingForm.select_account"
                ),
                "multiple-limit": 5
              },
              model: {
                value: _vm.form.accountsId,
                callback: function($$v) {
                  _vm.$set(_vm.form, "accountsId", $$v)
                },
                expression: "form.accountsId"
              }
            },
            _vm._l(_vm.accountsAvailable, function(account) {
              return _c(
                "el-option",
                {
                  key: account.id,
                  attrs: { label: account.label, value: account.id }
                },
                [
                  _c("span", { staticClass: "fleft" }, [
                    _vm._v(_vm._s(account.label))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fright gray-60 fs-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatWithOptions")(
                          account.balance,
                          { currencysymbol: account.currencySymbol },
                          true
                        )
                      )
                    )
                  ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "grey ml-1" }, [
            _vm._v(_vm._s(_vm.$l10n.__("5 comptes bancaires maximum")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aright mt-5" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submitForm }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }